// Meta (Facebook) Pixel — inicialización defensiva con el código base oficial.
export const FB_PIXEL_ID = '1545009850674181'

let initialized = false

export function initFacebookPixel() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (initialized) return
  initialized = true

  try {
    const w = window as any

    // Stub de fbq (cola de eventos) — no carga nada externo todavía.
    if (!w.fbq) {
      const fbq: any = function () {
        fbq.callMethod
          ? fbq.callMethod.apply(fbq, arguments)
          : fbq.queue.push(arguments)
      }
      w.fbq = fbq
      if (!w._fbq) w._fbq = fbq
      fbq.push = fbq
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.queue = []
    }

    // Inserta el script externo de forma segura (head/body), sin asumir
    // que ya exista un <script> en el documento.
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    // Si el script falla al cargar (p. ej. en un iframe sandbox o por un
    // bloqueador), evitamos que el error se propague como "Script error.".
    script.onerror = () => {
      /* silencioso */
    }
    const parent = document.head || document.body || document.documentElement
    if (parent) parent.appendChild(script)

    w.fbq('init', FB_PIXEL_ID)
    w.fbq('track', 'PageView')
  } catch (e) {
    // Nunca dejar que la inicialización del pixel rompa la app.
    if (typeof console !== 'undefined') {
      console.warn('No se pudo inicializar el Meta Pixel:', e)
    }
  }
}

// Helper para disparar eventos personalizados (ej. InitiateCheckout, Purchase)
export function fbTrack(event: string, data?: Record<string, unknown>) {
  if (typeof window === 'undefined') return
  try {
    const fbq = (window as any).fbq
    if (fbq) fbq('track', event, data)
  } catch {
    /* silencioso */
  }
}
